



























































































































































































































































// @ts-nocheck
import http from "@/axios/http-common";
import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import { resepStore } from "@/store/modules/resep";
import CardTemplateResep from "@/components/modal/CardTemplateResep.vue";
import { isEmpty, join, values, mapValues } from "lodash";
import { appModule } from "@/store/modules/app";
import { AxiosError } from "node_modules/axios";
import { userModule } from "@/store/modules/user";
import { storeSoap } from "@/store/modules/soap";
import { storePasien } from "@/store/modules/pasien";
import { storeCopy } from "@/store/modules/copy";
import { Textcomplete } from "@textcomplete/core";
import { TextareaEditor } from "@textcomplete/textarea";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import CardResepItems from "@/components/pemeriksaan/resep-obat/CardResepItems.vue";
import CardResepInputItem from "@/components/modal/CardResepInputItem.vue";
import moment from "moment";
import ResepObatSvc from "@/services/ResepObat";
import { refResepStore } from "@/store/modules/ReferensiResep";

interface Resep {
  id: number;
  text: string;
  depo_id: string;
  bb: number;
  alergi: string;
  diagnosis: string;
  dr_id: number;
  unit_id: string;
  pasien_cm: number;
  register_id: number;
  status: number;
  jenis_resep: number;
  tanggal: string;
  items: [];
}

@Component({
  components: {
    CardTemplateResep,
    CardResepItems,
    CardResepInputItem
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class ResepItemInput extends Vue {
  @Prop() resep: Resep;

  @Prop() register: number;

  @Prop() rm: number;

  @Ref() readonly inputText!: HTMLTextAreaElement;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  tab = "tab-text";
  // resep_item = [];
  resepEdit: Resep = null;
  input = {
    text: "",
    depo_id: "",
    bb: null,
    alergi: "",
    diagnosis: "",
    doctor_note: "",
    items: [],
    racikan: [],
    tgl_awal: "",
    tgl_akhir: ""
  };
  baseData = {
    dr_id: null,
    unit_id: null,
    pasien_cm: null,
    register_id: null
  };
  text = "";
  withSend = true;
  depoList = [
    {
      text: "Apotik Ralan Atas",
      value: "22"
    },
    {
      text: "Apotik Ralan Bawah",
      value: "02"
    },
    {
      text: "Apotik IGD",
      value: "05"
    },
    {
      text: "Apotik Ranap",
      value: "03"
    },
    {
      text: "Apotik HD",
      value: "08"
    }
  ];
  sending = false;
  saving = false;
  showInputItem = false;
  showTemplateModal = false;
  statusTemplateModal = false;
  templateMode = "list";
  rules = {
    required: value => !!value || "Kolom ini harus diisi"
  };
  textcomplete: Textcomplete;
  editor: TextareaEditor;
  resepText: HTMLTextAreaElement;
  // showTextComplete = true;
  showDurasiOptions = false;
  durasiResep = null;
  jenisResep = 1;
  durasiResepOptions = [
    {
      id: null,
      name: "Tidak ada"
    },
    {
      id: 2,
      name: "2 Hari"
    },
    {
      id: 3,
      name: "3 Hari"
    },
    {
      id: 4,
      name: "4 Hari"
    },
    {
      id: 5,
      name: "5 Hari"
    }
  ];
  jenisResepOptions = [
    // {
    //   id: 2,
    //   name: "Terjadwal"
    // },
    {
      id: 3,
      name: "Cito"
    },
    {
      id: 4,
      name: "Pulang"
    }
  ];
  sendStop = false;

  get isSent() {
    return this.resepEdit?.status >= 1;
  }

  get resepDeliverStatus() {
    return this.resepEdit?.status ?? "ee";
  }

  get isEditable() {
    return isEmpty(this.resepEdit) || this.resepEdit?.status < 2;
  }

  get disableSendBtn() {
    return (
      this.readOnly ||
      this.sending ||
      isEmpty(this.resepEdit) ||
      this.resepEdit?.status > 1
    );
  }

  get isShowSendBtn() {
    return (
      !isEmpty(this.resepEdit) &&
      this.resep?.jenis_resep == 2 &&
      this.resep?.tanggal > moment().format("YYYY-MM-DD") &&
      this.resep?.status == 0
    );
  }

  get dataSend() {
    return {
      dr_id: userModule.user.id,
      unit_id: userModule.user.unit_id,
      register_id: this.register,
      pasien_cm: this.rm,
      jenis_resep: this.jenisResep,
      kategori: "o",
      ...this.itemInput
    };
  }

  get isSoapExist() {
    return this.userSoap.length;
  }

  get userSoap() {
    return storeSoap.soapAll.filter(soap => {
      return soap.user.id == userModule.user.id;
    });
  }

  get userSoapRanap() {
    return SoapRanapStore.soap.filter(soap => {
      return soap.user_id == userModule.user.id;
    });
  }

  get editing() {
    return resepStore.inputResepMode;
  }

  get isUnitRalan() {
    return userModule.user.unit_id > "01" && userModule.user.unit_id < "30";
  }

  get pasienAlergi() {
    return storePasien.identitasPasien?.alergi;
  }

  get items() {
    const realItem = this.input?.items.filter(
      item => !Object.hasOwnProperty.call(item, "nama")
    );
    const itemRacikan = this.input?.items
      .filter(item => Object.hasOwnProperty.call(item, "nama"))
      .flatMap(item => item.items);

    return [...realItem, ...itemRacikan];
  }

  get racikan() {
    const item = this.input?.items
      .filter(item => Object.hasOwnProperty.call(item, "nama"))
      .map(item => {
        const { ...obat } = item;

        return obat;
      });

    return item;
  }

  get itemInput() {
    const input = { ...this.input };

    input.items = this.items;
    input.racikan = this.racikan;

    return input;
  }

  get isShowGlobalStopBtn() {
    return this.resep?.jenis_resep == 2 && this.resep?.status < 1;
  }

  get canMakeNewResepTerjadwal() {
    return (
      !this.resepEdit?.id && resepStore.anyResepTerjadwalToday.length === 0
    );
  }

  resep_item = [];
  items_for_input = [];

  mounted() {
    this.resepText = document.getElementById(
      "resepText"
    ) as HTMLTextAreaElement;

    appModule.setLoading(false);

    resepStore.hideInputResep();

    if (!this.input.tgl_awal) {
      this.input.tgl_awal = moment().format("YYYY-MM-DD");
    }

    // this.$nextTick(() => {
    //   this.resepEdit = this.resep;

    //   console.log("set resepEdit on mounted", this.resepEdit, this.resep);
    // });
  }

  preInputValidation() {
    if (this.isSent) {
      appModule.sendErrorAlert(
        "Tidak bisa mengubah resep yang telah terkirim. Untuk mengubah klik tombol merah 'Batal Kirim' terlebih dahulu."
      );

      return false;
    }

    if (!this.isEditable) {
      appModule.sendErrorAlert(
        "Tidak bisa mengubah resep karena telah diproses Instalasi Farmasi"
      );

      return false;
    }

    return true;
  }

  isEmpty(val: object) {
    return isEmpty(val);
  }

  showInputTemplate() {
    this.showTemplateModal = true;
    this.$nextTick(function() {
      this.templateMode = "input";
    });
  }

  showListTemplate() {
    this.showTemplateModal = true;
    this.$nextTick(function() {
      this.templateMode = "list";
    });
  }

  assignResepTemplate(val) {
    this.setResepItems(val);

    this.$nextTick(() => {
      this.showTemplateModal = false;
    });
  }

  clearInputField(): void {
    this.templateMode = "list";
    for (const key in this.input) {
      console.log("check type of ", key);
      if (Array.isArray(this.input[key])) {
        console.log(`${key} is array`);
        this.input[key] = [];
      } else {
        console.log(`${key} is ${typeof this.input[key]}`);
        this.input[key] = "";
      }
    }

    this.resepEdit = null;
    this.durasiResep = null;

    this.resep_item = [];
  }

  async save() {
    if (this.readOnly) return;
    if (!this.input.depo_id || !this.input.diagnosis) {
      appModule.sendErrorAlert(
        "Tidak dapat menyimpan bila kolom Depo dan Diagnosa belum diisi"
      );

      return false;
    }

    if (!this.saving) {
      this.saving = true;

      // batal kirim dulu kalau update
      if (this.resepEdit?.status == 1 && this.resepEdit?.id) {
        await this.undoSend(this.resepEdit.id, false);
      }

      const endPoint = this.resepEdit?.id
        ? ResepObatSvc.update(this.resepEdit.id, this.dataSend)
        : ResepObatSvc.create(this.dataSend);

      endPoint
        .then(async response => {
          console.log(
            "perlu send? ",
            this.withSend,
            this.input.tgl_awal <= moment().format("YYYY-MM-DD")
          );
          // send resep
          if (
            this.withSend &&
            this.input.tgl_awal <= moment().format("YYYY-MM-DD")
          ) {
            await this.send(response.data.data.id, false).then(() => {
              this.$emit("update-resep-list");
            });
          } else {
            this.$nextTick(async () => {
              this.$emit("update-resep-list");
            });
          }

          const notice = this.resepEdit?.id
            ? "Berhasil mengubah resep!"
            : "Berhasil membuat resep!";
          appModule.sendSuccessNotice(notice);
          appModule.closeNoticeWithDelay();

          this.closeInput();
        })
        // .catch(err => {
        //   this.showErrorAlert(err);
        // })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  showErrorAlert(err: AxiosError) {
    const dt = err.response;
    let message = "";
    if (!dt) {
      return;
    }
    if (dt["status"] == 422) {
      message = join(
        values(
          mapValues(err.response.data.errors, function(val) {
            return join(val, "; ");
          })
        ),
        "; "
      );
    } else {
      message = `ERR ${err.response.status}: ${err.response.data.message}`;
    }

    appModule.sendErrorAlert(message);
  }

  closeInput() {
    resepStore.hideInputResep();
    this.clearInputField();
  }

  async send(id, persistence = true) {
    if (this.readOnly) return;
    if (!this.sending) {
      if (
        this.resep?.tanggal <= moment().format("YYYY-MM-DD") ||
        this.input?.tgl_awal <= moment().format("YYYY-MM-DD")
      ) {
        this.sending = true;

        await http
          .putData(`/resep-obat-text/${id}/send`, null)
          .then(response => {
            // this.resepEdit.status = 1;
            if (persistence) {
              this.$emit("set-active-resep", response.data.data);
              this.$emit("update-resep-list");
            }

            appModule.sendSuccessNotice("Berhasil mengirim resep ke farmasi");
            appModule.closeNoticeWithDelay();
          })
          .catch(err => {
            this.showErrorAlert(err);
          })
          .then(() => {
            this.sending = false;
          });
      } else {
        alert("tidak bisa mengirim resep yang terjadwal untuk besok...");
      }
    }
  }

  async undoSend(id, persistence = true) {
    if (this.readOnly) return;
    if (!this.sending) {
      this.sending = true;

      await http
        .putData(`/resep-obat-text/${id}/undo-send`, null)
        .then(response => {
          // this.resepEdit.status = 0;
          if (persistence) {
            this.$emit("set-active-resep", response.data.data);
            this.$emit("update-resep-list");
          }
        })
        .catch(err => {
          this.showErrorAlert(err);
        })
        .then(() => {
          this.sending = false;
        });
    }
  }

  @Watch("showTemplateModal")
  changedShowTemplate(val) {
    this.$nextTick(() => {
      this.statusTemplateModal = val;
    });
  }

  get asesmenGadarMedis() {
    return AsesmenGadarMedisStore;
  }

  @Watch("editing")
  changedEditing(editing: boolean) {
    if (!editing) {
      this.clearInputField();
    } else {
      this.resepEdit = this.resep ? { ...this.resep } : null;
      // this.resepEdit = null;

      // assign frekuensi_id, rute_id, sediaan_id
      this.resepEdit?.items.map(item => {
        // if (!Object.hasOwnProperty.call(item, "frekuensi_id")) {
        item["frekuensi_id"] = item.frekuensi
          ? parseInt(item.frekuensi.id)
          : null;
        // }

        // if (!Object.hasOwnProperty.call(item, "rute_id")) {
        item["rute_id"] = item.rute ? parseInt(item.rute.id) : null;
        // }

        if (item.r) {
          item["sediaan_id"] = item.sediaan ? parseInt(item.sediaan.id) : null;
        }

        if (Object.hasOwnProperty.call(item, "items")) {
          item.items.map(subItem => {
            subItem.frekuensi_id = subItem.frekuensi
              ? parseInt(subItem.frekuensi.id)
              : null;
            subItem.rute_id = subItem.rute ? parseInt(subItem.rute.id) : null;

            return subItem;
          });
        }

        return item;
      });

      if (this.resepEdit && Object.keys(this.resepEdit).length) {
        for (const key in this.input) {
          this.input[key] = this.resepEdit[key];
        }

        this.resep_item = [...this.resepEdit?.items] ?? [];

        // @ts-ignore temp
        this.jenisResep = this.resepEdit.jenis_resep;
      } else {
        if (userModule.user.unit_id == "01") {
          this.input.diagnosis =
            this.asesmenGadarMedis.inputFields?.diagnosis_kerja ?? "";
          this.input.alergi = storePasien.identitasPasien.alergi;
          this.input.depo_id = "05";
        } else if (userModule.user.unit_id < "50") {
          this.input.diagnosis = String(this.userSoap[0]?.a ?? "");
          this.input.alergi = storePasien.identitasPasien.alergi;
          this.input.depo_id = userModule.user.zona == "3" ? "22" : "02";
        } else if (userModule.user.unit_id >= "50") {
          this.input.diagnosis = String(this.userSoapRanap[0]?.assesment ?? "");
          this.input.alergi = storePasien.identitasPasien.alergi;
          this.input.depo_id = "03";
        }
      }

      console.log(
        "tanggal",
        // this.input.tgl_awal,
        // this.input.tanggal,
        this.resep
      );

      if (!this.resep) {
        this.input.tgl_awal = moment().format("YYYY-MM-DD");
      } else {
        this.input.tgl_awal = this.resep.tanggal;
      }
    }
  }

  @Watch("resepEdit", { deep: true })
  changedResep(val: Resep) {
    console.log("changed resep", val);

    if (val) {
      // this.text = val.text;
      // this.resep_item = val.items;
      val.items.length > 0 ? val.items : [];
      this.jenisResep = val.jenis_resep;
    } else {
      this.text = null;
      // this.resep_item = [];
      this.jenisResep = null;
    }

    console.log("changed resep_item", this.resep_item);
  }

  get disabledJenisResep() {
    if (this.durasiResep > 1) {
      this.jenisResep = 2;
      return true;
    } else {
      this.jenisResep = 1;
      return false;
    }
  }

  get disabledDurasiResep() {
    if (this.jenisResep <= 2) {
      return false;
    } else {
      this.durasiResep = null;
      return true;
    }
  }

  @Watch("input.depo_id", { deep: true })
  changedInputDepoId(val: string) {
    resepStore.setDepoId(val);
  }

  @Watch("durasiResep")
  changeDurasiResep(val) {
    if (val && this.input.tgl_awal) {
      this.input.tgl_akhir = moment(this.input.tgl_awal)
        .add({ days: val - 1 })
        .format("YYYY-MM-DD");

      this.jenisResep = 2;
      // this.disabledDurasiResep = true;
    } else if (!val) {
      this.input.tgl_akhir = null;
      this.jenisResep = 1;
      // this.disabledDurasiResep = false;
    }
  }

  @Watch("jenisResep")
  changeJenisResep(val) {
    console.log("changeJenisResep", val, this.durasiResep);
    if (!val) {
      if (!this.durasiResep) {
        this.jenisResep = 1;
      } else {
        this.jenisResep = 2;
      }
    } else {
      if (this.durasiResep && val >= 3) {
        const conf = confirm(
          "Resep Terjadwal tidak bisa dibuat Resep Cito atau Pulang. Tetap jadikan Resep Cito atau Pulang dan menghapus durasi resep terjadwal?"
        );

        if (conf) {
          this.durasiResep = null;
          this.jenisResep = val;
        } else {
          this.jenisResep = null;
        }
      }
    }

    // this.disabledDurasiResep = true;
    if (val >= 3) {
      // this.$nextTick(() => {
      //   this.disabledDurasiResep = true;
      // });
    } else {
      // this.disabledDurasiResep = false;
    }
  }

  closeTemplateModal() {
    this.showTemplateModal = false;
    this.templateMode = null;
  }

  get statusPaste() {
    return storeCopy.copyResep;
  }

  get paste() {
    return storeCopy.pasteresep;
  }

  openResepInput() {
    this.showInputItem = true;
    this.items_for_input = [...this.resep_item];

    // this.setResepItems([
    //   {
    //     type: "nrc",
    //     obat_nama: "DOMPERIDON SYRUP 5MG/ML 60 ML   E",
    //     qty: "10",
    //     qty_unit: "BTL",
    //     harga: "3105",
    //     countedHarga: 31050,
    //     obat_id: "131DOMPSIR",
    //     ap_rute: null,
    //     ap_frekuensi: null,
    //     ap_dosis: "1",
    //     ap_tambahan: null,
    //     ap_template_id: null,
    //     ap_template_nama: null,
    //     r: "",
    //     frekuensi_id: 2,
    //     rute_id: 1,
    //     frekuensi: {
    //       id: 2,
    //       nama: "tiap 8 jam"
    //     },
    //     rute: {
    //       id: 1,
    //       nama: "oral"
    //     }
    //   }
    // ]);
  }

  get refRute() {
    return refResepStore.refRute;
  }

  get refFrekuensi() {
    return refResepStore.refFrekuensi;
  }

  get refSediaan() {
    return refResepStore.refSediaan;
  }

  closeResepInput() {
    this.showInputItem = false;
    this.items_for_input = [];
  }

  setResepItems(val) {
    console.log("setResepItems", val);
    this.resep_item = [...val];

    this.resep_item.map(item => {
      item.frekuensi_id = item.frekuensi_id ?? item.frekuensi?.id;
      item.frekuensi = this.refFrekuensi.find(
        sub => sub.id == item.frekuensi_id
      );

      item.rute_id = item.rute_id ?? item.rute?.id;
      item.rute = this.refRute.find(sub => sub.id == item.rute_id);

      item.stopped_at = item.stopped_at ?? null;

      if (item.r) {
        item["sediaan"] = this.refSediaan.find(
          sub => sub.id == item.sediaan_id
        );
      }

      return item;
    });

    this.input.items = val;
  }

  stopResep(resepId) {
    if (this.readOnly) return;
    const q = confirm(
      "Anda yakin stop resep ini? PERHATIAN: Stop resep ini akan menghapus resep terjadwal berikutnya."
    );

    if (q) {
      if (!this.sendStop) {
        this.sendStop = true;

        ResepObatSvc.stopResep(resepId)
          .then(resp => {
            console.log("stop resep", resp.data);
            if (resp.data.status) {
              this.$nextTick(() => {
                this.$emit("update-resep-list");
              });

              appModule.sendSuccessNotice("Berhasil Stop Resep");
              appModule.closeNoticeWithDelay();

              this.closeInput();
            }
          })
          .finally(() => {
            this.sendStop = false;
          });
      }
    }
  }
}
